import type { SVGProps } from 'react';

export const BookmarkFilled = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 20.25V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h9.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283V20.25L12 17.462 5.5 20.25Z" />
    </svg>
  );
};
